import type { SidebarConfig } from "app/components/sidebar3/dynamic-config/types";
import { getItemsList } from "app/components/sidebar3/dynamic-config/configs/sidebar31/getItemsList";
import { secondarySidebarMap } from "app/components/sidebar3/dynamic-config/configs/sidebar31/secondarySidebarMap";

export const sideBar31Config: SidebarConfig = {
    getPrimarySidebarListItems: getItemsList,
    secondarySidebarMap,
};
